/* ============
 * Deposit Systems Module State
 * ============
 */

export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/depositSystem/state.js